import { EditOperation } from "@acadia-ui/theme";
import { TOOLBAR_MODE } from "@acadia-ui/toolbar";
import { retryAtInterval } from "./retryAtInterval";

export default function applyFindReplaceToTable({ data, dataTableApi, syncData, toggleEditing = false, clearFilters = false }) {
	const tableApi = dataTableApi?.current;
	const dataProvider = tableApi?.dataProvider;

	if (!dataProvider) {
		syncData?.(data);
		return;
	}

	if (clearFilters) {
		dataProvider.filters = [];
		tableApi?.toolbarApi?.current?.setFilterValues?.([]);
	}

	const currentRowsById = new Map(
		(dataProvider.data || []).map((row, rowIndex) => {
			return [row.UniqueID, { row, rowIndex }];
		})
	);

	data.forEach((row) => {
		const currentRow = currentRowsById.get(row.UniqueID);
		if (!currentRow) {
			return;
		}

		Object.keys(row).forEach((key) => {
			if (key === "isEdited") {
				return;
			}

			if (row[key] !== currentRow.row[key]) {
				dataProvider.editStack.push(
					new EditOperation({
						rowId: row.UniqueID,
						rowIndex: currentRow.rowIndex,
						key,
						value: row[key]
					})
				);
			}
		});
	});

	dataProvider.update(data);
	if (dataProvider.editStack?.stack?.length > 0) {
		dataProvider.save();
	}

	syncData?.(data);

	if (toggleEditing) {
		retryAtInterval(
			() => {
				tableApi?.toolbarApi?.current?.changeActiveMode?.(TOOLBAR_MODE.EDIT);
			},
			() => tableApi?.toolbarApi?.current?.activeMode === TOOLBAR_MODE.EDIT
		);
	}
}
